

$(document).ready(function () {

  $('.headerWrapper .menuItem').on('click', function () {
    $(this).parent().children('.menuItem').removeClass('active');
    $(this).addClass('active');
  });

  $('body').on('click', '.backBtn', function () {
    window.history.back();
  })

  $('.bettingBannerParticipant').on('click', function () {
    let getElementOfEvent = $(this);
    if (getElementOfEvent) {
      if ($(getElementOfEvent).hasClass('highlighted')) {
        $(getElementOfEvent).removeClass('highlighted');
      } else {
        $(getElementOfEvent).addClass('highlighted');
      }
    }
  });

  $('body').on('click', '.profileHandler', function (e) {
    if ($(e.currentTarget).parent().hasClass('active')) {
      $(e.currentTarget).parent().removeClass('active');
    } else {
      $(e.currentTarget).parent().addClass('active');
    }
  });

  $('body').on('click', '.withdrawFundsModalBtn', function () {
    $('.withdrawFundModal').addClass('clicked');
  });

  $('body').on('click', '.addFundsModalBtn', function () {
    $('.addFundModal').addClass('clicked');
  });

  $('body').on('click', '.closeModalBtn', function () {
    $('.withdrawFundModal').removeClass('clicked');
    $('.addFundModal').removeClass('clicked');
  });

  $(document).mouseup(function (e) {
    var container = $(".profileWrapper ");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.profileWrapper ').removeClass('active');
    }
  });

  // $('body').on('click', '.singleBetHeader',function(e){
  //   if( $(e.currentTarget).parent().hasClass('showDetail') ){
  //     $(e.currentTarget).parent().removeClass('showDetail');
  //   }else {
  //     $(e.currentTarget).parent().addClass('showDetail');
  //   }
  // });

  $('body').on('click', '.mainCredit', function (e) {
    $(e.currentTarget).addClass('active');
    $('.mainMenuHolder a').removeClass('active');
    $('.profileNav a').removeClass('active');
    $('.profileWrapper').removeClass('active');
  });



  $('body').on('click', '.profileNav a', function (e) {
    if ($(e.currentTarget).hasClass('myBetsPageBtn')) {
      $('.mainCredit').removeClass('active');
      $('.mainMenuHolder .menuItem').removeClass('active');
      $('.profileNav a').removeClass('active');
      $(e.currentTarget).addClass('active');
      $('#myBetsPage').addClass('active');
      $(e.currentTarget).parent().parent().parent().removeClass('active');
    } else {
      $('.mainMenuHolder .menuItem').removeClass('active');
      $('.profileNav a').removeClass('active');
      $('.mainCredit').removeClass('active');
      $(e.currentTarget).addClass('active');
      $(e.currentTarget).parent().parent().parent().removeClass('active');
    }
  });

  $('body').on('click', '.leftPanel .menuItem', function (e) {
    $('.profileNav a').removeClass('active');
    $('.mainMenuHolder a').removeClass('active');
    $('body').removeClass('menuOpened');
  });

  $('body').on('click', '.menuItem', function (e) {

    if ($(e.currentTarget).attr('id') == 'myBetsPage') {
      $('.profileNav a').removeClass('active');
      $('.myBetsPageBtn').addClass('active');
      if (window.location.hash.includes('mybets')) {
        localStorage.removeItem('my-bets_user-data');
        if (localStorage.getItem('role') === 'User') {
          window.location.replace('#/mybets');
        } else if (localStorage.getItem('role') === 'Agent') {
          window.location.replace('#/mybetsusers-agent');
        } else {
          window.location.replace('#/mybetsusers');
        }
        window.location.reload();
      } else if (window.location.hash.includes('MyBets')) {
          $('body .my-bets-tabs__item:nth-child(3)').click();
      }
    } else {
      $('.profileNav a').removeClass('active');
    }
  });

});
